<template>
    <div class="MetrosEditor">	
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Станций: {{ApiData.length}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter"><ReFilter :masAllFilterParams="masAllFilterParams" v-model="objGetParams" v-on:filterapply="OnFilterApply"/></div>

		<card >
			<div v-if=(!canNotEdit)>
				<h5 v-if="isEdit==false"><i class="tim-icons icon-send text-success mr-3"></i>Добавление метро</h5>
				<h5 v-else><i class="tim-icons icon-send text-success mr-3"></i>Редактирование метро</h5>
			</div>
			<form action="" ref="form">
				<div class="row justify-content-between align-items-center" v-if=(!canNotEdit)>
					<div class="col-md mb-3">
						<el-select 
								class="w-100 px-0 select-primary"
								v-model="line" 
								placeholder="Выберите линию"
								size="large"
								clearable
							>
								<el-option
									class="select-primary"									
									:style="{color: line.color}" 
									v-for="line in LinesData"
									:key="line.id"
									:label="line.name"
									:value="line.id"
									>
								</el-option>
							</el-select>
					</div>
					<div class="col-md mb-3">
						<el-select 
								class="w-100 px-0 select-primary"
								v-model="zipal" 
								placeholder="Станция в зипале"
								size="large"
								filterable
								clearable
							>
								<el-option
									class="select-primary"
									v-for="subway in zipalData"
									:key="subway.id"
									:label="subway.name"
									:value="subway.id"
									>
								</el-option>
							</el-select>
					</div>
					<div class="col-md mb-3">
						<el-select 
								class="w-100 px-0 select-primary"
								v-model="tribita" 
								placeholder="Станция в трибита АБЦ"
								size="large"
								filterable
								clearable
							>
								<el-option
									class="select-primary"
									v-for="subway in tribitaData"
									:key="subway.id"
									:label="subway.name"
									:value="subway.id"
									>
								</el-option>
							</el-select>
					</div>							
					<div class="col-md mb-3">
						<input type="text" placeholder="Название метро на карте" class="form-control" v-model="objMetro.metroName">
					</div>
					
					<div class="d-flex px-3 mb-3">
						<button v-if="isEdit==false" class="btn btn-success btn-simple mr-2" type="button" @click="createMetro()">Создать</button>
						<button v-else class="btn btn-success btn-simple mr-3" type="button" @click="updMetro()">Сохранить</button>
						<button class="btn btn-danger btn-simple" type="button" @click="cancelMetro()">Отменить</button>
					</div>
				</div>				
				<div class="cellmap-wrapper">				
					<div class="cellmap"> 
						<re-subway-map-editor ref="cellEditor" :name="objMetro.metroName" :color="objMetro.color" :stations="ApiData" :readonly="canNotEdit" v-model="metro_map"  ></re-subway-map-editor>
					</div>
				</div>
				<div class="mt-3"> Данные с карты: {{metro_map}} </div>
			</form>
			
		</card>

		<card class="CellAdd-table">
			<el-table 
				:data="ApiData" 
				:highlight-current-row="false" 
				:cell-style="{height:'100px'}" 
				style="width: 100%;" 
				class="el-table--scrollable-x">
				<el-table-column
					sortable
					width="80"
					label="ID"
					property="id"
				></el-table-column>
				<el-table-column
					sortable
					width="100"
					label="Зипал"
					property="zipal"
				></el-table-column>
				<el-table-column
					sortable
					width="180"
					label="трибита"
					property="tribita"
				><template v-slot="scope">{{ scope.row.tribita }}<span v-if="scope.row.tribita"> - {{ tribitaName(scope.row.tribita) }}</span></template></el-table-column>
				<el-table-column
					sortable
					width="120"
					label="Линия"
					property="line"					
				></el-table-column>
				<el-table-column
					sortable
					min-width="180"
					label="Название метро"
					property="name"
				></el-table-column>
				
				
				<el-table-column
					min-width="180"
					label="На карте"
					property="cellStyle"
				>
					<template v-slot="scope">	
						<base-button class="ml-3 btn btn-simple btn-primary" @click="showThisCell(scope.$index, scope.row)">
							<i class="tim-icons icon-square-pin"></i>
							Показать на карте
						</base-button>											
					</template>
				</el-table-column>
				
				<!-- <el-table-column
					min-width="240"
					height="100"
					label="Координаты метро"
					:property="{latitude}, {longitude}"
				></el-table-column>
				-->
				<el-table-column
					width="110"
					label="Действие"
					v-if=(!canNotEdit)
				>	
					<template v-slot="scope">						
						<el-tooltip content="Редактировать метро" placement="top">
							<el-button class="no-border my-0">
								<base-button  class="ml-3 btn btn-icon btn-simple btn-primary" @click="editMetro(scope.$index, scope.row)">
									<i class="tim-icons icon-pencil"></i>
								</base-button>											
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<!--el-table-column
					min-width="80"
					label="agent_id"
					property="agent_id"
				>	
				</el-table-column-->
				<el-table-column
					width="110"
					label="Действие"
					align="right"      
					v-if=(!canNotEdit)              	
				>
					<template v-slot="scope">						
						<ReActionBtns :masActions="masActions[scope.$index]"/>
					</template>
				</el-table-column>
			</el-table>
			<!-- <Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination> -->
		</card>
		

		
    </div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button, Popover } from 'element-ui';
// import { BaseSwitch } from 'src/components';
// import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReSubwayMapEditor from 'src/our_components/ReSubwayMapEditor.vue';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'metros_editor-page',
	components: {
	    [Table.name]: Table,
		[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		[Popover.name]: Popover,
		// BaseSwitch,
		ReActionBtns,
		ReSubwayMapEditor,
		ReFilterBtn,
        ReFilter,
        // ReFormPrinter,
        // Pagination,
	},
	data() {
		return {
			ApiData: [],
			LinesData: [],
			zipalData: [],
			tribitaData: [],
			tribitaNames: {},
			zipal: '',
			tribita: '',
			masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{region:78},

			line: '', // линия метро. при изменении пишет данные в objMetro
			objMetro: {},

			metro_map: '{"center":null, "polygon":[]}',
			polygon:'[]',
			latitude: 0,
			longitude: 0,
			curMetro: [],
			masActions:[],	
			bShowFilter: false,
			masMetrosAdd: [],
			isEdit: false,
			canNotEdit: false,
			masObjects_total: 0,
			count2page: 10,
		};
	},
	methods: {
		getApiData(){
			let filter = {list:true};
			this.objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
				filter = {...filter, ...this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams))};
			}			
			this.$GVO.ApiCall('cat_subway.GET',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;

						this.masActions = [];
						for (let i = 0; i < this.ApiData.length; i++) {
							this.masActions.push([
								{
									actionType: 'switcher',
									label_on: 'Вкл',
									label_off: 'Выкл',
									action_model: this.ApiData[i].act=='1'?true:false,						
									onClickApi: {apiMethod: 'CHANGE_ACT_RESTRICTIONS',apiParam:{obj:'cat_subway',flt:{id:this.ApiData[i].id}}},
								},
							]);
						}

						if(objApi.readonly == 1){
							this.canNotEdit = true;
						}else {this.canNotEdit = false;}
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));

			this.LinesData = [];
			this.$GVO.ApiCall('cat_subway.LINES',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.LinesData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));

			this.zipalData = [];
			this.$GVO.ApiCall('cat_subway.ZIPAL_GET',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.zipalData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));

			this.tribitaData = [];
			this.tribitaNames = {};
			this.$GVO.ApiCall('cat_subway.tribita_GET',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.tribitaData = objApi.data;
						for(const r of this.tribitaData){
							this.tribitaNames[r.id] = r.name;
						}
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));	

		},
		tribitaName(id){
			return this.tribitaNames[id]||'';
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('cat_subway.GET_FILTER',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},			
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		getSaveData(){
			const iData = {
			 		id: this.objMetro.id,
			 		name: this.objMetro.metroName,
			 		//act: this.objMetro.cellAct,
			 		value: JSON.stringify(this.objMetro.polygon),
					//color: this.objMetro.color,
					line: this.objMetro.line,
					latitude: this.objMetro.latitude,
					longitude: this.objMetro.longitude,
			 		//agent_id: this.agent_id,
					zipal: this.zipal,
					tribita: this.tribita,
			}

			const objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(objGetParams)) {
				iData.region=objGetParams.region
			}			

			return iData;
		},
		createMetro() {
			const iData= this.getSaveData();
			this.$GVO.ApiCall('INS', {obj:'cat_subway', iData })
			.then((objApi) => {
				if(objApi.success === true){
					this.cancelMetro();
					this.getApiData();
					/*
					if(objApi.data.length > 0) {
						this.masMetrosAdd = objApi.data;			
					}
					this.getApiData();					
					this.objMetro.metroName = '';
					this.polygon = '[]';
					this.$refs.cellEditor.startEdit();		
					*/		
				}else {
					this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание станций метро.</p>')
				} 
									
			}).catch(errorObjApi => console.error(errorObjApi));
			// console.log('Функция добавляет метро. Нужен INS, {obj:}');
		},
		cancelMetro(){
			this.polygon = '';
			this.isEdit = false;
			this.objMetro.line = '';
			this.objMetro.metroName = '';
			this.objMetro.id = '';
			this.zipal = '';
			this.tribita = '';
			this.metro_map =JSON.stringify({center:[this.objMetro.latitude, this.objMetro.longitude], polygon:[[]]});
			this.line = '';
		},
		editMetro(index, row){
			this.metro_map = JSON.stringify({center:[row.latitude,row.longitude],polygon: JSON.parse(row.value||'[[]]')});
			this.objMetro.latitude = row.latitude;
			this.objMetro.longitude = row.longitude;
			this.isEdit = true;
			this.line = row.line;
			this.objMetro.metroName = row.name;
			this.objMetro.zipal = row.zipal;
			this.objMetro.id = row.id;
			this.zipal = row.zipal;
			this.$refs.cellEditor.startEdit(true);
			this.$refs.form.scrollIntoView({behavior: 'smooth', block: 'center'});
		},
		updMetro() {
			const uData= this.getSaveData();
			// this.metroName = this.objMetro.metroName;
			// this.metroValues = this.polygon;
			// this.id = this.objMetro.id;

			this.$GVO.ApiCall('UPD', {obj:'cat_subway',flt:{id: this.id}, uData	})
			.then((objApi) => {
				if(objApi.success === true){
					this.cancelMetro();
					this.getApiData();
					/*
					if(objApi.data.length > 0) {
						this.masMetrosAdd = objApi.data;			
					}
					this.getApiData();					
					this.objMetro.metroName = '';
					this.polygon = '[]';
					this.$refs.cellEditor.startEdit();		
					*/		
				}else {
					this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на редактирование станций метро.</p>')
				} 
									
			}).catch(errorObjApi => console.error(errorObjApi));

			// console.log('Функция добавляет метро. Нужен UPD, {obj:}');
		},
		showThisCell(index, row){
			//При клике на строке таблицы сот (на кнопку), стирать на карте все ячейки и отображать только текущую.
			//по строке потом будет ховер с данными, поэтому при клике по кнопке выделяем цветом полигон на карте

			this.objMetro.id = row.id;
			this.objMetro.value = row.value;

			for (let i = 0; i < this.ApiData.length; i++) {
				if(this.ApiData[i].id == this.objMetro.id){
					this.ApiData[i].cellStyle = '#FF8D72'; 
					
					this.$refs.cellEditor.drawStations();
					this.$refs.cellEditor.focus(this.ApiData[i].value);
					this.$refs.form.scrollIntoView({behavior: 'smooth', block: 'center'});
					//console.log('this.ApiData[i].value', this.ApiData[i].value);
				
				} else {
					this.ApiData[i].cellStyle = ''; 
				}
			}
		},
		formatter (row, column) {
			return row.id;
		},

	},	
	watch:{
		line(val){
			let line=this.LinesData.find(l=>l.id==val);
			if(!line) line={ id: null, color: 'black' };
			this.objMetro.line = line.id
			this.objMetro.color = line.color
		},
		metro_map(val){
			try{
				const data=JSON.parse(val);
				this.objMetro.latitude=data.center[0];
				this.objMetro.longitude=data.center[1];
				this.objMetro.polygon = data.polygon;
			}catch(e){
				alert('Ошибка разбора данных с карты. Такого никогда не было и вот опять.');
			}
			//this.obj
		},
		// polygon(val){
		// }
	},		
	mounted() {
		// this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style>
.MetrosEditor .cellmap-wrapper {
	position: relative;
	width: 100%;
	height:  100%;
	padding: 0 20px;
}
.MetrosEditor .btn-cellmap {
	position: absolute;
	right: 110px;
	top: 5px;
}
</style>
